<template>
    <div class="category-management">
      <a-button type="primary" style="float: right;" @click="showAddCategoryModal">新增分类</a-button>
  
      <!-- 分类列表：分页显示 -->
      <a-table
        :dataSource="categories"
        :columns="categoryColumns"
        rowKey="id"
        :pagination="pagination"
        @change="handleTableChange"
        style="margin-top: 20px;"
      >
        <template v-slot:bodyCell="{ column, record, index }">
          <template v-if="column.key === 'sn'">
                {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
          </template>
          <template v-if="column.key == 'name'">
            {{ record.name }}
          </template>
          <template v-if="column.key === 'parentId'">
            {{ getParentCategoryName(record.parentId) }}
          </template>
          <template v-if="column.key === 'operation'">
            <a-space>
              <a href="javascript:;" @click="showEditCategoryModal(record)">修改</a>
              <a-popconfirm title="确认删除该分类?" @confirm="deleteCategory(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </a-space>
          </template> 
        </template>
      </a-table>
  
      <!-- 分类新增/编辑模态框 -->
      <a-modal
        v-model:visible="categoryModalVisible"
        title="分类操作" 
        @ok="handleCategorySubmit"
        @cancel="handleCategoryCancel"
      >
        <a-form :label-col="labelCol"
        :rules="rules"
        ref="formRef"
        :model="categoryForm">

          <a-form-item label="排序" name="sort"   ref="sort">
            <a-input v-model:value="categoryForm.sort" placeholder="请输入排序" />
          </a-form-item>

          <a-form-item label="分类名称" name="name"   ref="name">
            <a-input v-model:value="categoryForm.name" placeholder="请输入分类名称" />
          </a-form-item>


          <a-form-item label="上级分类">
            <!-- <a-select v-model:value="categoryForm.parentId" placeholder="选择上级分类">
              <a-select-option v-for="category in categories" :key="category.id" :value="category.id">
                {{ category.name }}
              </a-select-option>
            </a-select> -->
            <a-tree-select
              v-model:value="categoryForm.parentId"
              show-search
              style="width: 100%"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              placeholder="Please select"
              allow-clear
              tree-default-expand-all
              :tree-data="treeData" 
              :field-names="{
              children: 'children',
              label: 'categoryName',
              value: 'categoryId',
            }"
              tree-node-filter-prop="categoryName"
            > 
            </a-tree-select>
          </a-form-item> 
        </a-form> 
      </a-modal>
    </div>
  </template>
  
  <script setup>
  import { ref, reactive, onMounted,toRaw,watch } from 'vue';
  import http from '@/shared/http.service';
  import { Uris } from '@/shared/const';
  import { Table, Space, Button, Popconfirm, Modal, Form, Input, Select } from 'ant-design-vue';
  
  const formRef = ref(); 
  
  const categoryModalVisible = ref(false); // 模态框显示/隐藏
  const categoryForm = reactive({
    id: null, // 分类ID，新增时为null
    name: '',
    sort:'',
    parentId: null,
  });
  const value = ref(); 
  const categories = ref([]); // 分类列表 
  const treeData = ref([]); // 树
  const pagination = reactive({
    current: 1,
    pageSize: 10,
    total: 0,
  }); // 分页配置
  
  const labelCol = { style: { width: '90px' } }; // 表单label宽度

  watch(value, () => {
  console.log("value"+value.value);
});
  // 获取分类列表（包括分页）
  const fetchCategories = async (page=1) => {
    try {
        // {params: { pageIndex: page, pageSize: pagination.pageSize },}
         
        http.post(Uris.NewsCategoryList, { pageIndex: page, pageSize: pagination.pageSize  }).subscribe(result=>{
        // 处理后端返回的数据
        const { list, totalCount, totalPageCount, pageIndex, pageSize } = result;
        // 更新分类列表
        categories.value = list;
        pagination.total = totalCount;
        pagination.current = pageIndex;
        pagination.pageSize = pageSize;
        pagination.totalPageCount = totalPageCount;
      }); 
      // 获取分类树
      await http.get(Uris.NewsCategoryTree).subscribe(result=>{ 
        treeData.value=result; 
      });
    } catch (error) {
      console.error('Error fetching categories', error);
    }
  };
  
  // 获取上级分类名称
  const getParentCategoryName = (parentId) => {
    const category = categories.value.find((cat) => cat.id === parentId);
    return category ? category.name : '无';
  };
  
  // 分页变化处理
  const handleTableChange = (pagination) => {
    
    fetchCategories(pagination.current);
  };
  
  // 新增分类
  const showAddCategoryModal = () => {
    categoryForm.id = null;
    categoryForm.name = '';
    categoryForm.sort = '';
    categoryForm.parentId = null;
    categoryModalVisible.value = true;
  };
  
  // 编辑分类
  const showEditCategoryModal = (category) => {
    categoryForm.id = category.id;
    categoryForm.name = category.name;
    categoryForm.sort = category.sort;
    categoryForm.parentId = category.parentId;
    categoryModalVisible.value = true;
  };
  
  // 提交分类操作（新增或编辑）
  const handleCategorySubmit =  () => {  
    // 表单验证
    formRef.value.validate().then(() => {
      try {  
      if (categoryForm.id) {
       // 编辑分类
       http.post(Uris.NewsCategoryEdit, categoryForm).subscribe(t=>{
           fetchCategories(pagination.current); // 重新加载分类列表
           categoryModalVisible.value = false;
       });
      } else {
       // 新增分类
       http.post(Uris.NewsCategoryAdd, categoryForm).subscribe(t=>{
           fetchCategories(pagination.current); // 重新加载分类列表
           categoryModalVisible.value = false;
       });
     } 
   } catch (error) {
     console.error('Error submitting category', error);
   }
    })
    .catch(error => {
      console.log('error', error);
    }); 
  };
   
  // 取消操作
  const handleCategoryCancel = () => {
    categoryModalVisible.value = false;
    formRef.value.resetFields();
  };
  
  // 删除分类
  const deleteCategory = async (category) => {
    try {
      http.get(`${Uris.NewsCategoryDelete}?id=${category.id}`).subscribe(t=>{
        if(t==0)
        {
          alert("请先删除文章,再删除该分类!");
        }
        fetchCategories(pagination.current); 
      }); 
    } catch (error) {
      console.error('Error deleting category', error);
    }
  };
  
  // 初始化
  onMounted(() => {
    fetchCategories(pagination.current);
  });
  
 
  const rules = {
  name: [
    {
      required: true,
      message: '请输入分类名称',
      trigger: 'change',
    }, 
  ]
};
  
  // 表格列配置
  const categoryColumns = [
    {
      title: '序号',
      dataIndex: 'sn',
      key: 'sn', 
      width: 200,
      align: 'center',
    },
    {
      title: '分类名称',
      width: 200,
      dataIndex: 'name',
      key: 'name',
      align: 'center',
    },
    {
      title: '上级分类',
      width: 200,
      dataIndex: 'parentId',
      key: 'parentId',
      align: 'center',
      render: (text) => getParentCategoryName(text),
    },
    {
      title: '排序',
      width: 200,
      dataIndex: 'sort',
      key: 'sort',
      align: 'center', 
    },
    {
      title: '操作',
      width: 200,
      key: 'operation',
      scopedSlots: { customRender: 'operation' },
      align: 'center',
    },
  ];
  </script>
  
  <style scoped>
  p {
  padding-left: 20px;
}

  </style>
  